import React from 'react';

/**
 * Visual badge/vector brand component exactly matching:
 * "KODU" in bold black sans-serif font
 * "TARA!" in bold white text enclosed inside a rounded black badge / pill
 */
export const KoduTaraBadge = ({ size = "md", className = "" }) => {
    // Size variants
    const sizes = {
        sm: {
            text: "text-lg",
            badgeText: "text-lg",
            badgePadding: "px-1.5 py-0.5 rounded-[1px]",
            gap: "gap-1",
        },
        md: {
            text: "text-2xl",
            badgeText: "text-2xl",
            badgePadding: "px-2.5 py-0.5 rounded-md",
            gap: "gap-1.5",
        },
        lg: {
            text: "text-3xl sm:text-4xl md:text-5xl",
            badgeText: "text-3xl sm:text-4xl md:text-5xl",
            badgePadding: "px-3 sm:px-4 py-1 sm:py-1.5 rounded-lg",
            gap: "gap-1.5 sm:gap-2",
        },
    };

    const s = sizes[size] || sizes.md;

    return (
        <span className={`inline-flex items-center font-black tracking-tight select-none uppercase ${s.gap} ${className}`}>
            <span className={`${s.text} text-black font-black tracking-tight leading-none`}>
                KODU
            </span>
            <span className={`bg-black text-white ${s.badgeText} ${s.badgePadding} font-black tracking-tight leading-none inline-flex items-center`}>
                TARA!
            </span>
        </span>
    );
};

export const Logo = ({ size = "md", className = "" }) => {
    return (
        <div className={`flex items-center ${className}`}>
            <KoduTaraBadge size={size} />
        </div>
    );
};

export default Logo;
